import React from 'react';
import Sidebar from 'components/shared/sidebar/container';
import { SIDEBAR_MODE_ADMIN } from 'components/constants';
export default function ViewAdminDashboard() {
    return (React.createElement("div", null,
        React.createElement(Sidebar, { type: SIDEBAR_MODE_ADMIN })));
}
;
